import { Href, Link } from 'expo-router';
import { Pressable, StyleSheet, View } from 'react-native';

import {
  Button,
  HeaderTitleText,
  IconArrowBack,
  IconChevronLeft,
  LogoSvg,
  tokens,
  useMqSelect,
} from '@fhs/ui';
import { HeaderFrame } from '@fhs/ui';
import {
  BACK_BUTTON_CART_PAGE,
  BACK_BUTTON_CHECKOUT_PAGE,
} from '@fhs-legacy/frontend/src/utils/test-ids';

import UserPointsDisplay from './user-points-display';

type Props = { title: string; href: Href };

export function CartHeader(props: Props) {
  return (
    <HeaderFrame>
      <HeaderFrame.Left>
        <Link href={props.href} asChild>
          <Pressable
            testID={BACK_BUTTON_CART_PAGE}
            accessibilityRole="link"
            accessibilityLabel="Go back"
            accessibilityHint="Returns to the previous screen"
            aria-label="Go back"
          >
            <IconChevronLeft
              accessible={false}
              accessibilityElementsHidden
              importantForAccessibility="no"
              aria-hidden
              size={24}
              style={styles.desktopIconButton}
            />
          </Pressable>
        </Link>
      </HeaderFrame.Left>
      <HeaderFrame.Middle>
        <HeaderTitleText text={props.title} />
      </HeaderFrame.Middle>
      <UserPointsDisplay />
    </HeaderFrame>
  );
}

export function CheckoutHeader(props: Props) {
  const showCheckoutHeader = useMqSelect({ $gteDesktop: true }, false);

  if (!showCheckoutHeader) {
    return <CartHeader {...props} />;
  }

  return (
    <HeaderFrame style={styles.container}>
      <View style={styles.inner}>
        <HeaderFrame.Middle>
          <Link href={props.href} asChild>
            <Button type="ghost" style={styles.button} testID={BACK_BUTTON_CHECKOUT_PAGE}>
              <Button.Icon>
                <IconArrowBack />
              </Button.Icon>
              <Button.Text>Back to Cart</Button.Text>
            </Button>
          </Link>
          <LogoSvg height={36} />
        </HeaderFrame.Middle>
      </View>
    </HeaderFrame>
  );
}

export const OrderConfirmationHeader = CartHeader;

const styles = StyleSheet.create({
  container: {
    height: 80,
  },
  inner: {
    maxWidth: 908,
    marginHorizontal: 'auto',
    flexDirection: 'row',
  },
  button: {
    borderColor: tokens.colors.$blackOpacity10,
    width: 179,
    position: 'absolute',
    right: '100%',
    transform: 'translateX(-100%)',
  },
  desktopIconButton: {
    borderRadius: 80,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    padding: 11,
  },
});
